import type { HoverActionKey } from "owa-outlook-service-option-store";
import loc from "owa-localize";
import { archive } from "owa-locstrings/lib/strings/archive.locstring.json";
import { deleteItem } from "owa-locstrings/lib/strings/deleteitem.locstring.json";
import { markAsRead } from "owa-locstrings/lib/strings/markasread.locstring.json";
import { markAsUnread } from "owa-locstrings/lib/strings/markasunread.locstring.json";
import { moveTo } from "owa-locstrings/lib/strings/moveto.locstring.json";
import { unpin } from "owa-locstrings/lib/strings/unpin.locstring.json";
import { default as Archive } from "owa-fluent-icons-svg/lib/icons/ArchiveRegular";
import { default as Checkmark } from "owa-fluent-icons-svg/lib/icons/CheckmarkRegular";
import { default as Delete } from "owa-fluent-icons-svg/lib/icons/DeleteRegular";
import { default as FlagIconFilled } from "owa-fluent-icons-svg/lib/icons/FlagFilled";
import { default as Flag } from "owa-fluent-icons-svg/lib/icons/FlagRegular";
import { default as FolderArrowRight } from "owa-fluent-icons-svg/lib/icons/FolderArrowRightRegular";
import { default as MailRead } from "owa-fluent-icons-svg/lib/icons/MailReadRegular";
import { default as Mail } from "owa-fluent-icons-svg/lib/icons/MailRegular";
import { default as PinIconFilled } from "owa-fluent-icons-svg/lib/icons/PinFilled";
import { default as Pin } from "owa-fluent-icons-svg/lib/icons/PinRegular";
import { default as Settings } from "owa-fluent-icons-svg/lib/icons/SettingsRegular";
import { completeIcon, flagButtonColor, flagButtonFilledColor, } from "owa-mail-listitem-styles/lib/scss/FlagIconStyles.scss";
import { pinButtonColor, pinButtonFilledColor, archiveButtonColor, markAsReadButtonColor, deleteButtonColor, moveButtonColor, } from "owa-mail-listitem-styles/lib/scss/MailListItemIconStyles.scss";
import { pinTitle, settingsTitle } from "./getHoverActionIcon.locstring.json";
import { flagTitle, unflagTitle } from "./getFlagCompleteHelper.locstring.json";
import classnames from "owa-classnames";
import type { HoverActionIconProps } from "../types/IconProps";

export default function getHoverActionIcon(action: HoverActionKey, isFlagged: boolean, isComplete: boolean, isPinned: boolean, unreadCount: number): HoverActionIconProps {
    switch (action) {
        case "Archive":
            return {
                title: loc(archive),
                key: "archiveIcon",
                id: action,
                iconName: Archive,
                buttonClasses: classnames(archiveButtonColor),
            };
        case "Move":
            return {
                title: loc(moveTo),
                key: "moveIcon",
                id: action,
                iconName: FolderArrowRight,
                buttonClasses: classnames(moveButtonColor),
            };
        case "Delete":
            return {
                title: loc(deleteItem),
                key: "deleteIcon",
                id: action,
                iconName: Delete,
                buttonClasses: classnames(deleteButtonColor),
            };
        case "ReadUnread":
            const hasUnread = unreadCount && unreadCount > 0;
            return {
                title: hasUnread ? loc(markAsRead) : loc(markAsUnread),
                key: "markReadIcon",
                id: action,
                iconName: hasUnread ? MailRead : Mail,
                buttonClasses: classnames(markAsReadButtonColor),
            };
        case "FlagUnflag":
            const flagClass = classnames(isComplete ? completeIcon : isFlagged ? flagButtonFilledColor : flagButtonColor);
            return {
                title: isComplete ? loc(flagTitle) : isFlagged ? loc(unflagTitle) : loc(flagTitle),
                key: isComplete ? "completeIcon" : "flagIcon",
                id: action,
                iconName: isComplete ? Checkmark : isFlagged ? FlagIconFilled : Flag,
                buttonClasses: flagClass,
            };
        case "PinUnpin": {
            const pinClasses = classnames(isPinned ? pinButtonFilledColor : pinButtonColor);
            
            return {
                title: isPinned ? loc(unpin) : loc(pinTitle),
                key: "pinIcon",
                id: action,
                iconName: isPinned ? PinIconFilled : Pin,
                buttonClasses: pinClasses,
            };
        }
        case "Settings": {
            return {
                title: loc(settingsTitle),
                key: "settingsIcon",
                id: action,
                iconName: Settings,
                buttonClasses: classnames(moveButtonColor),
            };
        }
        case "None":
        default:
            return { title: "", key: "", iconName: "" };
    }
}
